/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const TemplateService = require('./templateService');

/**
 * Defines the module for the template utility dependencies.
 */
const templateModule = angular
    .module('enervee_utils.template', [])
    .factory('TemplateService', TemplateService);

module.exports = templateModule;
